module.exports = __webpack_public_path__ + "static/media/photo210.1e29097e.jpg";